export default __webpack_public_path__ + "static/media/Hero BG.37d400b8.png";